export default __webpack_public_path__ + "static/media/8070-maaria.037bb164.pdf";